import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScrollbarModule } from '@hdms/shared/ui-core';

import { ContactBodyModule } from '../../header-contact/contact-body/contact-body.module';
import { ContactFooterModule } from '../../header-contact/contact-footer/contact-footer.module';
import { ContactHeaderModule } from '../../header-contact/contact-header/contact-header.module';

import { ContactPopoverContentComponent } from './contact-popover-content.component';

@NgModule({
  declarations: [ContactPopoverContentComponent],
  imports: [CommonModule, ContactBodyModule, ContactHeaderModule, ContactFooterModule, ScrollbarModule],
  exports: [ContactPopoverContentComponent]
})
export class ContactPopoverContentModule {}
